import { clsx, colorSet } from '@components/Provider';
import { styled } from '@material-ui/core';
import { ReactNode, Children } from 'react';

interface Props {
  className?: string;
  children?: ReactNode;
}

const ButtonSection = ({ children, className }: Props) => {
  const child = Children.toArray(children);

  return (
    <Wrapper
      className={clsx(className, {
        single: child.length === 1,
        double: child.length === 2
      })}
    >
      {children}
    </Wrapper>
  );
};

export default ButtonSection;

const Wrapper = styled('div')({
  borderTop: `1px solid ${colorSet.gray300}`,
  padding: '16px 24px',
  display: 'flex',
  justifyContent: 'space-between',
  '&.single': {
    '& > button': {
      width: '100%'
    }
  },
  '&.double': {
    gap: 7,
    '&>button': {
      width: '100%'
    }
  }
});
